var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 51,
    r: 51,
    fill: "#F3F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 58.3027C59.2152 58.3027 65.875 51.323 65.875 42.7132C65.875 34.1034 59.2152 27.1238 51 27.1238C42.7848 27.1238 36.125 34.1034 36.125 42.7132C36.125 51.323 42.7848 58.3027 51 58.3027Z",
    stroke: "#6358EB",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4531 71.9438C30.7377 67.7959 34.0239 64.3514 37.9814 61.9566C41.9389 59.5617 46.4282 58.3009 50.998 58.3009C55.5679 58.3009 60.0572 59.5617 64.0147 61.9566C67.9722 64.3514 71.2584 67.7959 73.543 71.9438",
    stroke: "#6358EB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogos);
export default __webpack_public_path__ + "static/media/Logos.2409ee9c903aaf4d27ba83ef3658b9ac.svg";
export { ForwardRef as ReactComponent };